// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca2b868d","465":"d336859d"}[chunkId] + ".chunk.js";
};